import styles from './index.module.scss'

export function ResponseSkeleton() {
  return (
    <div className={styles.formStream}>
      <div style={{ width: '30%' }} className={styles.label} />
      <div className={styles.textRow} />
      <div style={{ width: '70%', marginTop: '.3rem' }} className={styles.label} />
    </div>
  )
}
